var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingButton',{staticClass:"text-nowrap btn btn-primary btn-sm",attrs:{"loading":_vm.downloading,"type":"button","small":""},nativeOn:{"click":function($event){return _vm.download($event)}}},[_vm._v("\n  Download\n")])}
var staticRenderFns = []

export { render, staticRenderFns }